<template>
	<TeamingBadge
		class="beta-badge"
		size="SMALL"
	>
		{{ translate( `title` ) }}
	</TeamingBadge>
</template>

<script>
import TranslateMixin from "../mixins/TranslateMixin";
import TeamingBadge from "./TeamingBadge";

export default {
	name: "BetaBadge",
	teamingPackage: "common-ui",
	mixins: [ TranslateMixin, ],
	components: {
		TeamingBadge,
	},
};
</script>

<style lang="scss" scoped>
.beta-badge {
	text-transform: uppercase;
	font-weight: 600;
}
</style>
